export default __webpack_public_path__ + "static/media/image4.bee24c4b.png";